module.exports = __webpack_public_path__ + "img/Ambulance.51c2fe0.png";